import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, observable, runInAction } from "mobx";
class Installation {
    get subscription() {
        return this.store.subscriptions.get(this.data.subscriptionId);
    }
    constructor(data, store){
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Installation.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Installation.prototype, "subscription", null);
export { Installation };
